export function ConnectGuideWindows() {
  return (
    <svg viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-xs mx-auto block" aria-hidden="true">
      {/* ── Taskbar (Windows 11 style) ── */}
      <rect x="0" y="192" width="240" height="28" fill="#1a1a1a" />
      {/* Windows logo (⊞) centered */}
      <rect x="108" y="197" width="6" height="6" fill="#ffffff" opacity="0.9" />
      <rect x="116" y="197" width="6" height="6" fill="#ffffff" opacity="0.9" />
      <rect x="108" y="205" width="6" height="6" fill="#ffffff" opacity="0.9" />
      <rect x="116" y="205" width="6" height="6" fill="#ffffff" opacity="0.9" />
      {/* System tray: clock */}
      <text x="222" y="210" textAnchor="middle" fontSize="7" fill="#cccccc">12:00</text>
      {/* System tray: WiFi icon (highlighted = clickable) */}
      <rect x="196" y="196" width="18" height="18" rx="3" fill="#0078d4" opacity="0.35" />
      <text x="205" y="209" textAnchor="middle" fontSize="11" fill="#ffffff">&#x1F4F6;</text>
      {/* Arrow pointing up from WiFi icon to panel */}
      <polygon points="205,192 199,182 211,182" fill="#0078d4" />

      {/* ── WiFi flyout panel ── */}
      <rect x="52" y="4" width="184" height="175" rx="8" fill="#2b2b2b" stroke="#3a3a3a" strokeWidth="0.5" />
      {/* Panel header */}
      <text x="144" y="24" textAnchor="middle" fontSize="11" fontWeight="600" fill="#ffffff">WLAN</text>
      <line x1="60" y1="32" x2="228" y2="32" stroke="#3a3a3a" strokeWidth="0.5" />

      {/* Network 1 – connected, highlighted */}
      <rect x="60" y="36" width="168" height="40" rx="5" fill="#0078d4" />
      {/* WiFi signal bars */}
      <rect x="72" y="52" width="3" height="8" rx="1" fill="#ffffff" opacity="0.5" />
      <rect x="77" y="48" width="3" height="12" rx="1" fill="#ffffff" opacity="0.7" />
      <rect x="82" y="44" width="3" height="16" rx="1" fill="#ffffff" />
      <text x="92" y="52" fontSize="11" fill="#ffffff" fontWeight="500">Dein-WLAN</text>
      <text x="92" y="65" fontSize="9" fill="#c0d8f0">Verbunden, gesichert</text>
      <line x1="60" y1="80" x2="228" y2="80" stroke="#3a3a3a" strokeWidth="0.3" />

      {/* Network 2 */}
      <rect x="60" y="84" width="168" height="36" rx="5" fill="transparent" />
      <rect x="72" y="96" width="3" height="8" rx="1" fill="#888" />
      <rect x="77" y="92" width="3" height="12" rx="1" fill="#aaa" />
      <rect x="82" y="88" width="3" height="16" rx="1" fill="#ccc" />
      <text x="92" y="100" fontSize="11" fill="#e0e0e0">Dein-WLAN-5G</text>
      <text x="92" y="112" fontSize="9" fill="#999">Gesichert</text>
      <line x1="60" y1="124" x2="228" y2="124" stroke="#3a3a3a" strokeWidth="0.3" />

      {/* Network 3 */}
      <rect x="60" y="128" width="168" height="36" rx="5" fill="transparent" />
      <rect x="72" y="140" width="3" height="5" rx="1" fill="#666" />
      <rect x="77" y="137" width="3" height="8" rx="1" fill="#888" />
      <rect x="82" y="133" width="3" height="12" rx="1" fill="#aaa" />
      <text x="92" y="144" fontSize="11" fill="#c0c0c0">Gäste-WLAN</text>
      <text x="92" y="156" fontSize="9" fill="#777">Gesichert</text>
    </svg>
  );
}
